import { CustomValidators } from './../../../common/validators/CustomValidators';
import { OnlineAccountValidation } from './../../../models/enums/Auth/OnlineAccountValidationEnum';
import { LoadingService } from './../../../services/loading.service';

import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';


enum FormModeType {
  Login = 1,
  ForgotPassword = 2,
  ResetSuccessfulySent = 3
}

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  //@Input() onClose: () => void;


  @Input() isModal: boolean;
  @Output() onSuccess = new EventEmitter();
  faTimesCircle = faTimesCircle;
  loginForm: FormGroup;
  RecoverPasswordForm: FormGroup;
  isSubmitted = false;
  formMode = FormModeType.Login;
  forgotPasswordConfirmation = false;
  forgotPassword = false;
  props: any;
  emailOldVal: any;
  constructor(private loadingService: LoadingService, private authService: AuthService, private router: Router, private formBuilder: FormBuilder, public translateService: TranslateService) {

  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2}|aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel)$")])],
      password: ['', Validators.required],
      hiddenValidation: ['']
    });
    this.RecoverPasswordForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, CustomValidators.pattern(/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2}|aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel)$/)])],
    });
  }

  get formModeType(): typeof FormModeType {
    return FormModeType;
  }
  get formControls() { return this.loginForm.controls; }

  register() {

    this.router.navigate(['/register']);
    this.onSuccess.emit(true);


  }



  ForgotYourPassword() {
    this.formMode = FormModeType.ForgotPassword;

  }
  showLogin() {
    this.formMode = FormModeType.Login;
  }




  login() {
    this.loginForm.controls['hiddenValidation']?.setErrors(null);

    this.isSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    });

    this.authService.login(this.loginForm.value).subscribe(res => {
      this.loadingService.updateLoadingState(false);
      if (res) {
        if (this.isModal != null && this.isModal) {
          this.onSuccess.emit(true);
        }
        else {
          this.router.navigateByUrl('/home');
        }


      }
      else {
        this.loginForm.controls['email']?.setErrors({ 'Invalid': true });
        this.loginForm.controls['password']?.setErrors({ 'Invalid': true });

        return;
      }


    }, err => {
      this.loadingService.updateLoadingState(false);
      //Bad Request

      if (err.status == 422 && err.error.isServerValidation) {
        const validationCode = err.error.code;
        //Todo: Get the msgs from a source.
        switch (validationCode) {
          case OnlineAccountValidation.NotAllRequiredParamsPasseed: //Not all required parameter passed
            break;
          case OnlineAccountValidation.UserNotExist: //User not exist
            //this.loginForm.controls['email']?.setErrors({'UserNotExist': 'User Not Exist'});
            this.loginForm.controls['email']?.setErrors({ 'InvalidCred': 'Invalid Credentials' });
            this.loginForm.controls['password']?.setErrors({ 'InvalidCred': 'Invalid Credentials' });
            break;
          case OnlineAccountValidation.InvalidCredentials://Invalid Cred
            this.loginForm.controls['email']?.setErrors({ 'InvalidCred': 'Invalid Credentials' });
            this.loginForm.controls['password']?.setErrors({ 'InvalidCred': 'Invalid Credentials' });
            break;
            case OnlineAccountValidation.AccountLockout://Invalid Cred
            this.loginForm.controls['email']?.setErrors({ 'AccountLockout': 'AccountLockout' });
            break;
        }


      }
      else {//SHow soemthing went wrong msg
        this.loginForm.controls['hiddenValidation']?.setErrors({ 'Default': 'Something Went Wrong, Please Try Again!' });
      }

      const validationErrors = err.errors;



    });

  }

  onEmailChange() {
    let errors = this.loginForm.controls["password"].errors;
    if (errors != null && errors.InvalidCred != null) {
      this.loginForm.controls["password"].setErrors({ "InvalidCred": null })
      this.loginForm.controls["password"].updateValueAndValidity();
      this.loginForm.controls["email"].setErrors({ "InvalidCred": null })
      this.loginForm.controls["email"].updateValueAndValidity();
    }
    let emailErrors = this.loginForm.controls["email"].errors;
    if (emailErrors != null && emailErrors.InvalidCred != null) {
      this.loginForm.controls["email"].setErrors({ "InvalidCred": null })
      this.loginForm.controls["email"].updateValueAndValidity();
    }
    if (emailErrors != null && emailErrors.AccountLockout != null) {
      this.loginForm.controls["email"].setErrors({ "AccountLockout": null })
      this.loginForm.controls["email"].updateValueAndValidity();
    }
  }
  onPasswordChange() {
    let errors = this.loginForm.controls["password"].errors;
    if (errors != null && errors.InvalidCred != null) {
      this.loginForm.controls["password"].setErrors({ "InvalidCred": null })
      this.loginForm.controls["password"].updateValueAndValidity();
      this.loginForm.controls["email"].setErrors({ "InvalidCred": null })
      this.loginForm.controls["email"].updateValueAndValidity();
    }
    let emailErrors = this.loginForm.controls["email"].errors;
    if (emailErrors != null && emailErrors.InvalidCred != null) {
      this.loginForm.controls["email"].setErrors({ "InvalidCred": null })
      this.loginForm.controls["email"].updateValueAndValidity();
    }
  }



  onSubmitRecoverPassword() {

    if (this.RecoverPasswordForm.invalid) {
      return;
    }
    this.RecoverPasswordForm.controls['email'].markAsTouched()

    this.authService.forgotPassword(this.RecoverPasswordForm.value.email).subscribe(res => {
      this.formMode = FormModeType.ResetSuccessfulySent;
    }, err => {
      this.RecoverPasswordForm.controls['email'].setErrors({ 'somethingWentWrong': '' });
    })

  }

  emilBlur(event) {


    let val = event.target.value
    if (val != null && val != "") {
      val = (val as string).trim();
      let emailControl= this.RecoverPasswordForm.controls['email'];
      let errors = this.RecoverPasswordForm.controls['email'].errors;
      if (errors == null) {

        this.emailOldVal = val;
        this.authService.checkIfEmailExist(val).subscribe(res => {

          if (res) {
            this.RecoverPasswordForm.controls['email'].setErrors({ 'notExist': null });
            this.RecoverPasswordForm.controls['email'].updateValueAndValidity();

          }
          else {
            this.translateService.get('EmailNotExist').subscribe(res => {
              emailControl.setErrors({ 'notExist': res });

            })
          }
        })

      }
    }

  }

}
